import { GetApp } from "@mui/icons-material";
import {
    Box,
    Button,
    Card,
    CardContent,
    Divider,
    LinearProgress,
    Typography,
} from "@mui/material";
import { ChangeEvent, useContext, useEffect, useState } from "react";
import * as XLSX from "xlsx";
// import { DataImportService } from "../../services/DataImportService";
import { Global_CTX } from "../../contexts/global-ctx";
import { DataImportService } from "../../services/data-import/DataImportService";
import Authorize from "../Authorize";
import { AuthorizeFallback } from "../AuthorizeFallback";
import UserContext, { User_Type } from "../UserContext";

const readExcelFileAndCreateUsers = async (
    bin: string | ArrayBuffer | null | undefined,
    orgCode: any,
    apiKey: any
): Promise<any[]> => {
    const wb = XLSX.read(bin, { type: "binary" });

    const sheets = wb.Sheets;

    for (const sheetName of wb.SheetNames) {
        const sheet = sheets[sheetName];

        if (!sheet) continue;

        try {
            const json = XLSX.utils.sheet_to_json(sheet);

            console.log(json);

            if (json.length === 0) continue;

            const [data, err] = await DataImportService.createBulkUsers(
                json,
                orgCode,
                apiKey
            );

            if (data || err) {
                return [data, err]; // ✅ return result immediately
            }
        } catch (err) {
            console.error(`Error processing sheet ${sheetName}:`, err);
        }
    }

    return [];
};

export const DataImport = () => {
    const [loading, setLoading] = useState<"loading" | "initial" | "finished">(
        "initial"
    );
    const { user } = useContext(UserContext);
    const { feedback, set_feedback } = useContext(Global_CTX);
    const [organizationCode, setOrganizationCode] = useState("");
    const [apiKey, setApiKey] = useState("");
    const [fname, setFname] = useState("Select file");
    const handleFileUpload = async (ev: ChangeEvent<HTMLInputElement>) => {
        set_feedback({ ...feedback, loading: true });
        setLoading("loading");
        const file = ev.target.files && ev.target.files[0];
        file && setFname(file.name);
        const reader = new FileReader();
        if (file) {
            reader.onload = async (evt) => {
                const binary = evt.target?.result;
                const [data, error] = await readExcelFileAndCreateUsers(
                    binary,
                    organizationCode,
                    apiKey
                );

                console.log(data, error);

                setLoading("finished");
                if (error) {
                    set_feedback({
                        loading: false,
                        message: { title: error.message },
                        severity: "error",
                        show: true,
                    });

                    return;
                }

                set_feedback({
                    loading: false,
                    message: { title: data?.message ?? "" },
                    severity: "success",
                    show: true,
                });
            };

            reader.readAsBinaryString(file);
        }
    };

    useEffect(() => {
        if (user?.user_type === User_Type.Admin) {
            setOrganizationCode(user?.organization?.code);
            setApiKey(user.organization.apiKey[0].key);
        }
    }, [user?.user_type]);

    return (
        <Authorize
            opName="CREATE USER"
            fallback={
                <AuthorizeFallback message="You're not authorized to import students" />
            }
        >
            <Card>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Typography gutterBottom variant="h4">
                            Import Users
                        </Typography>

                        <Button
                            variant="outlined"
                            startIcon={<GetApp />}
                            href="/user-template.xlsx"
                            download
                        >
                            download template
                        </Button>
                    </Box>
                    <Divider />

                    <div>
                        <div style={{ padding: "1rem" }}>
                            <Button variant="outlined" component="label">
                                <input
                                    onChange={handleFileUpload}
                                    hidden
                                    type="file"
                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                />
                                Choose File
                            </Button>
                            <Typography
                                variant="caption"
                                style={{ fontWeight: "bold", padding: "1rem" }}
                            >
                                {fname}
                            </Typography>
                        </div>

                        <Typography
                            // variant="caption"
                            style={{ fontStyle: "normal" }}
                            gutterBottom
                        >
                            The file format must be .xlsx and it must contain
                            valid data (branch,card,disabled,group,
                            name,password,pin,privilege,verified). Also, ensure
                            that the column names are: ('branch', 'card',
                            'name', 'group' and 'name', 'password', 'pin',
                            'privilege', 'verified').
                        </Typography>

                        {loading === "loading" && <LinearProgress />}
                    </div>
                </CardContent>
            </Card>
        </Authorize>
    );
};
export default DataImport;
